module.exports = __webpack_public_path__ + "b4e7d8a6e72845d5e585bb508704eff0.pdf";